import api from '../services/api'
import { RESET } from '../redux/game'

// Actions
const FETCHING_PROJECTS_START = 'ascension/projects/fetching'
const FETCHING_PROJECTS_SUCCESS = 'ascension/projects/success'
const FETCHING_PROJECTS_ERROR = 'ascension/projects/error'

const SUBMITTING_PROJECTS_START = 'ascension/projects/submitting'
const SUBMITTING_PROJECTS_SUCCESS = 'ascension/projects/submitted'
const SUBMITTING_PROJECTS_ERROR = 'ascension/projects/submitting_error'

const DELETE_PROJECTS_START = 'ascension/projects/deleting'
const DELETE_PROJECTS_SUCCESS = 'ascension/projects/deleted'
const DELETE_PROJECTS_ERROR = 'ascension/projects/deleting_error'

// Reducer
const initialState = {
  isLoading: false,
  isLoaded: false,
  error: null,
  isSubmitting: false,
  isDeleting: false,
  projects: []
}

const reducer = (state = initialState, action = {}) => {
  switch (action.type) {
    case FETCHING_PROJECTS_START: {
      return {
        ...state,
        isLoading: true,
        projects: null,
        error: null
      }
    }
    case FETCHING_PROJECTS_SUCCESS: {
      return {
        ...state,
        isLoading: false,
        projects: action.data
      }
    }
    case FETCHING_PROJECTS_ERROR: {
      return {
        ...state,
        isLoading: false,
        error: action.data
      }
    }
    case SUBMITTING_PROJECTS_START: {
      return {
        ...state,
        isSubmitting: true,
        error: null
      }
    }
    case SUBMITTING_PROJECTS_SUCCESS: {
      return {
        ...state,
        isSubmitting: false,
        error: null,
        projects: state.projects.map((project) => {
          if (project.id === action.data.project) {
            return { ...project, usedInRound: action.data.round, businessId: action.data.business || 0 }
          }
          if (project.usedInRound === action.data.round) {
            return { ...project, usedInRound: null, businessId: 0 }
          }
          return project
        })
      }
    }
    case SUBMITTING_PROJECTS_ERROR: {
      return {
        ...state,
        isLoading: false,
        error: action.data
      }
    }
    case DELETE_PROJECTS_START: {
      return {
        ...state,
        isDeleting: true,
        error: null
      }
    }
    case DELETE_PROJECTS_SUCCESS: {
      return {
        ...state,
        isDeleting: false,
        error: null,
        projects: state.projects.map((project) => {
          if (project.usedInRound === action.data.round) {
            return { ...project, usedInRound: null, businessId: null }
          }
          return project
        })
      }
    }
    case DELETE_PROJECTS_ERROR: {
      return {
        ...state,
        isLoading: false,
        error: action.data
      }
    }
    case RESET: {
      return initialState
    }
    default: return state
  }
}

export default reducer

export function fetchingProjectsStart () {
  return {
    type: FETCHING_PROJECTS_START
  }
}

export function fetchingProjectsSuccess (projects) {
  return {
    type: FETCHING_PROJECTS_SUCCESS,
    data: projects
  }
}

export function fetchingProjectsError (error) {
  return {
    type: FETCHING_PROJECTS_ERROR,
    data: error
  }
}

export function submittingProjectsStart () {
  return {
    type: SUBMITTING_PROJECTS_START
  }
}

export function submittingProjectsSuccess (round, project, business) {
  return {
    type: SUBMITTING_PROJECTS_SUCCESS,
    data: { round, project, business }
  }
}

export function submittingProjectsError (error) {
  return {
    type: SUBMITTING_PROJECTS_ERROR,
    data: error
  }
}

export function deleteProjectsStart () {
  return {
    type: DELETE_PROJECTS_START
  }
}

export function deleteProjectsSuccess (round) {
  return {
    type: DELETE_PROJECTS_SUCCESS,
    data: { round }
  }
}

export function deleteProjectsError (error) {
  return {
    type: DELETE_PROJECTS_ERROR,
    data: error
  }
}

// Action Creators
export function fetchProjects (team, round) {
  return async (dispatch) => {
    dispatch(fetchingProjectsStart())

    try {
      const response = await api.getProjects(team, round)
      dispatch(fetchingProjectsSuccess(response))
    } catch (e) {
      dispatch(fetchingProjectsError(e))
    }
  }
}

export function submitProject (team, round, project, business) {
  return async (dispatch) => {
    dispatch(submittingProjectsStart())

    try {
      await api.updateProjectDecision(team, round, project, business)
      dispatch(submittingProjectsSuccess(round, project, business))
    } catch (e) {
      dispatch(submittingProjectsError(e))
    }
  }
}

export function deleteProject (team, round) {
  return async (dispatch) => {
    dispatch(deleteProjectsStart())

    try {
      await api.deleteProjectDecision(team, round)
      dispatch(deleteProjectsSuccess(round))
    } catch (e) {
      dispatch(deleteProjectsError(e))
    }
  }
}
